import { AfterViewInit, ChangeDetectorRef, Component, Injectable, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { UserService } from 'src/app/services/user.service';
import { DeviceService } from 'src/app/services/device.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { Subscription, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { Error429Service } from 'src/app/services/error429.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-recargas-historial',
  templateUrl: './recargas-historial.component.html',
  styleUrls: ['./recargas-historial.component.css']
})
export class RecargasHistorialComponent {
  userEstablecimientos: any[] = []; //Información básica de cada uno de los dispositivos
  devicesAndEstablishmentInfo: any[] = []; //Información completa de los dispositivos y establecimientos
  devicesReferences: string = ""; //String con los dispositivos de los que necesitamos información
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage : string =""; //Mensaje de error
  displayedColumns: string[] = ['f_inicio', 'est_id', 'est_name', 'tank_num', 'beertype', 'litres_input','litres_output', 'output_type'];
  dataSource :any;
  recargas: any = [];
  devices: any = [];
  alarmasData: any = [];
  establecimientosId: any = [];

  modalidad: any[] = [
    {value: 0, name: 'Todas'},
    {value: 1, name: 'Tanque'},
    {value: 2, name: 'Dispositivo'}
  ];
  selectedModalidad: number =  0;
  userData: any = [];
  establecimientosData: any = [];

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private alarmasSubscription: Subscription | undefined;
  private establecimientoSubscription: Subscription | undefined;

  constructor(private deviceService: DeviceService, private router: Router, private error429: Error429Service,
  private userDataService: UserDataService){
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    if(this.userData.pro_id == 4){
      this.displayedColumns = ['f_inicio', 'est_id', 'est_name', 'cliente_name', 'tank_num', 'beertype', 'litres_input','litres_output', 'output_type'];
    }
    this.establecimientoSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next: resp => {
        this.establecimientosData = resp;
        for(let x = 0; x < resp.length; x++){
          this.establecimientosId.push(resp[x].id);
          for(let j = 0; j < resp[x].devices.length; j++){
            this.devices.push(resp[x].devices[j]);
          }
        }
      },error: err => {
        console.log(err.error)
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },complete: () => {
        const recargasData = new FormData();
        recargasData.append('establishments', JSON.stringify(this.establecimientosId));
        this.alarmasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
          next: resp => {
            for(let i = 0; i < resp.charges.length; i++){
              let tipo = "No encotrado";
              if(resp.charges[i].output_type == 1){
                tipo = "Retirada normal";
              } 
              if(resp.charges[i].output_type == 2){
                tipo = "Retirada por incidencia";
              } 
              this.recargas.push({
                //dev_reference: this.obtenerDeviceReference(resp.charges[i].device_id),
                //dev_label: this.obtenerDeviceLabel(resp.charges[i].device_id),
                est_name: resp.charges[i].establishment.est_name,
                f_inicio: resp.charges[i].charged_at,
                tank_num: resp.charges[i].tank_num,
                est_id: resp.charges[i].establishment.external_id,
                //dev_id: resp.charges[i].device_id,
                litres_input: this.soloDosDecimalesConComa(resp.charges[i].litres_input),
                litres_output: this.soloDosDecimalesConComa(resp.charges[i].litres_output),
                output_type: tipo,
                beertype: resp.charges[i].beertype.name,
                cliente_name: this.obtenerNombreClienteDelEstablecimiento(resp.charges[i].establishment_id),
              });
            }
          },error: err => {
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },complete: () => {
            console.log(this.recargas);
            this.dataSource = new MatTableDataSource(this.recargas);
            //Filtrado personalizado
            this.dataSource.filterPredicate = (data: any, filter: string) => {
              if(this.userData == 4){
                const dataStr = this.displayedColumns
                .filter(key => key !== 'dev_id')
                .map(key => data[key])
                .join('')
                .toLowerCase();
          
                return dataStr.includes(filter);
              } else {
                const dataStr = this.displayedColumns
                .filter(key => key !== 'dev_id' && key !== 'cliente_name')
                .map(key => data[key])
                .join('')
                .toLowerCase();
          
                return dataStr.includes(filter);
              }
            };
            setTimeout(() => {
              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;
            }, 0);
            this.datosRecibidos = true;
          }
        })
      }
    });
  }

  obtenerNombreClienteDelEstablecimiento(id:number): string {
    const establecimiento = this.establecimientosData.find((establecimiento:any) => establecimiento.id == id)
    return establecimiento ? establecimiento.cliente.razon_social : "Cliente no encontrado";
  }

  soloDosDecimalesConComa(numero: number){
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
    }
  }

  parseLitresOutput(value: string): number {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num < 0 ? 0 : num;
  }

  ngOnDestroy(): void {
    if (this.alarmasSubscription) {
      this.alarmasSubscription.unsubscribe();
    } 
    if (this.establecimientoSubscription) {
      this.establecimientoSubscription.unsubscribe();
    }
  }

  descargarExcel(){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Fecha de Recarga', key: 'f_inicio', width: 30 },
      { header: 'ID Establecimiento', key: 'est_id', width: 30 },
      { header: 'Establecimiento', key: 'est_name', width: 30 },
      ...(this.userData.pro_id === 4 ? [{ header: 'Cliente', key: 'cliente_name', width: 30 }] : []),
      { header: 'Número de Tanque', key: 'tank_num', width: 30 },
      { header: 'Cerveza', key: 'beertype', width: 10 },
      { header: 'Litros Introducidos', key: 'litres_input', width: 30 },
      { header: 'Litros Retirados', key: 'litres_output', width: 30 },
      { header: 'Tipo', key: 'output_type', width: 10 },
    ];

    console.log(this.recargas);
    this.recargas.forEach((alarma:any) => {
      const formattedAlarma = {
        est_id: alarma.est_id,
        dev_reference: alarma.dev_reference,
        dev_label: alarma.dev_label,
        est_name: alarma.est_name,
        f_inicio: alarma.f_inicio,
        tank_num: alarma.tank_num,
        litres_input: alarma.litres_input,
        litres_output: alarma.litres_output,
        output_type: alarma.output_type,
        beertype: alarma.beertype,
        cliente_name: alarma.cliente_name
      };
      const row = worksheet.addRow(formattedAlarma);
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const columnWidth = cell.text.length + 3;
        const currentColumn = worksheet.getColumn(colNumber);
        if (currentColumn) {
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Historial de recargas de tanques DataBeer.xlsx');
    });
  }

  obtenerDeviceReference(deviceId: number){
    const device = this.devices.find((device:any) => device && device.id === deviceId);
    return device ? device.dev_reference : "Referencia no encontrada";
  }

  obtenerDeviceLabel(deviceId: number){
    const device = this.devices.find((device:any) => device && device.id === deviceId);
    return device ? device.dev_label : "Etiqueta no encontrada";
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
